import React from 'react';
import { Modal } from '../Modal/Modal';

// Diálogo de confirmación genérico (hoy la app solo usa window.confirm en
// todas partes). Se agrega aquí, sin tocar los usos existentes de
// window.confirm, específicamente para el aviso de "cambios sin guardar"
// del formulario de usuario — reutilizable después si se quiere.
export function ConfirmDialog({ open, title = 'Confirmar', message, confirmLabel = 'Continuar', cancelLabel = 'Cancelar', onConfirm, onCancel, danger = false }) {
  if (!open) return null;
  return (
    <Modal isOpen={open} onClose={onCancel} title={title} size="max-w-sm" fullWidth={false}>
      <div className="text-sm text-gray-700">{message}</div>
      <div className="mt-5 flex justify-end gap-2">
        <button type="button" onClick={onCancel} className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm">
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={`px-3 py-2 rounded-lg text-white text-sm shadow-sm hover:opacity-95 ${danger ? '' : ''}`}
          style={{ backgroundColor: danger ? '#DC2626' : '#2563EB' }}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
